module.exports = __webpack_public_path__ + "img/org04.3b286177.png";